import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Assessmentservice from '../../services/Assessmentservice';
import './Assessment.css';
import './ArchivedHistory.css';
import Loading from '../Loading';

const Assessment = () => {
      // Convert string to Title Case
      const toTitleCase = (str) => {
        if (!str) return '-';
        return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
      };
    // Format only date (MM/DD/YYYY)
    const formatOnlyDate = (dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    };
  const navigate = useNavigate();
    // Track selected row for highlight
    const [selectedAssessmentRow, setSelectedAssessmentRow] = useState(null);
  // State declarations
  const [assessments, setAssessments] = useState([]);
  const [filteredAssessments, setFilteredAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showFilterPanel, setShowFilterPanel] = useState(null);
  // Remove filterValues and focusedFilterInput from parent state

  // Fetch decrypted params and LoadAssessmentMaster data on mount
  const [decryptedParams, setDecryptedParams] = useState({ sessionid: '', patientId: '', hraId: '' });
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Get decrypted params first
        const decryptResponse = await Assessmentservice.getDecryptParams();
        if (!decryptResponse || !decryptResponse.data || !decryptResponse.data.sessionid || !decryptResponse.data.patientId) {
          return;
        }
        setDecryptedParams({
          sessionid: decryptResponse.data.sessionid,
          patientId: decryptResponse.data.patientId,
          hraId: decryptResponse.data.hraId
        });
        // Now load assessment master data
        const masterResponse = await Assessmentservice.loadAssessmentMaster();
        if (masterResponse && masterResponse.data) {
          setAssessments(masterResponse.data);
        }
      } catch (error) {
        if (error.isSessionExpired) {
          // Keep loading spinner visible when session is expired
          return;
        }
        setDecryptedParams({ sessionid: '', patientId: '', hraId: '' });
        setAssessments([]);
        return;
      }
      setLoading(false);
    };
    fetchData();
  }, [navigate]);
  const handleViewReport = async (selectedArchivedItem) => {
    //setLoading(true);
  try {
    if (!selectedArchivedItem) {
      console.error('No archived item selected');
      return;
    }

    // Check if p is "In Progress"
    if (selectedArchivedItem.status === "In Progress") {
      // Store the status in session storage for the popup
      sessionStorage.setItem('assessmentViewStatus', 'InProgress');

      // Calculate the centered position for the popup
      const width = 1000;
      const height = 800;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      // Open the view report in a popup window
      const popupWindow = window.open(
        '/view-report',
        '',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,status=no`
      );

      if (popupWindow) {
        popupWindow.focus();
      }
      //  else {
      //   alert('Please allow popups for this website to view the report.');
      // }
      return;
    }

    // Get the stored archived assessment data
    const storedData = JSON.parse(sessionStorage.getItem('archivedAssessmentData'));
    if (!storedData) {
      alert('No archived assessment data found');
      return;
    }
    // Find the matching record with the selected item
    const selectedRecord = storedData.find(item =>
      item.create_date === selectedArchivedItem.createDate &&
      item.user_name === selectedArchivedItem.registrar
    );

    if (!selectedRecord) {
      alert('Record not found for selected item');
      return;
    }

    // Call the API with the obx_id from the stored data (allows obx_id = 0 or null)
    const response = await Assessmentservice.getAssessmentQuestionAnswer(selectedRecord.obx_id);

    if (response && response.data) {
      // Store the status and report data in session storage
      sessionStorage.setItem('assessmentViewStatus', 'Completed');
      sessionStorage.setItem('assessmentQuestionAnswer', response.data);

      // Calculate the centered position for the popup
      const width = 1000;
      const height = 800;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      // Open the view report in a popup window
      const popupWindow = window.open(
        '/view-report',
        '',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,status=no`
      );

      if (popupWindow) {
        popupWindow.focus();
      } else {
        alert('Please allow popups for this website to view the report.');
      }
    }
  } catch (error) {
    console.error('Error in handleViewReport:', error);
    alert('Error viewing report. Please try again.');
  }
  //setLoading(false);
};

const handleDownloadPDF = async (selectedArchivedItem) => {
  setLoading(true);
  try {
    if (!selectedArchivedItem) {
      alert('No archived item selected');
      setLoading(false);
      return;
    }

    // Get the stored archived assessment data
    const storedData = JSON.parse(sessionStorage.getItem('archivedAssessmentData'));
    if (!storedData) {
      alert('No archived assessment data found');
      setLoading(false);
      return;
    }
    // Find the matching record with the selected item
    const selectedRecord = storedData.find(item =>
      item.create_date === selectedArchivedItem.createDate &&
      item.user_name === selectedArchivedItem.registrar
    );

    if (!selectedRecord) {
      alert('Record not found for selected item');
      setLoading(false);
      return;
    }

    const name = selectedRecord.name;
    const assessmentId = selectedRecord.id;
    const sessionID = sessionStorage.getItem('assessmentSessionId');
    const obx_id = selectedRecord.obx_id;

    // List of names for AssessmentPDF
    const pdfNames = [
      "H2060", "H1700-1", "H1700-B", "H1700-2", "H1700-A1", "H2060-A", "H1700-A", "2067",
      "H2060-B", "Community First Choice Assessment", "H2067",
      "Personal Care Assessment Form (PCAF) For Children Ages 4-20",
      "701B LTC Comprehensive Assessment", "Medical Necessity and Level of Care Assessment",
      "701T Non-Community Placement Assessment", "H1700-3",
      "Freedom of Choice English", "Freedom of Choice Spanish", "Freedom of Choice Creole",
      "Plan of Care", "2515", "Plan of Care Summary", "LTC Supplemental Assessment",
      "Disclosure of Protected Health Information", "2506A", "Rights and Responsibilities Checklist",
      "Contingency and Back-Up Plan", "Consent for Voluntary Suspension - Spanish",
      "Consent for Voluntary Suspension Creole", "Consent for Voluntary Suspension - English",
      "PDO Representative Agreement", "PDO Participant/DSW Agreement", "Death Notification Form",
      "PDO Initial Referral", "PDO Pre-Screening Tool Spanish", "Financial Release",
      "PDO Consent Form", "PDO Pre-Screening Tool English", "PC-PTSD-5 Screening Tool",
      "ACE-Q-Child", "ACE-Q Teen"
    ];

    // If status is "In Progress"
    if (selectedArchivedItem.status === "In Progress") {
      if (pdfNames.includes(name)) {
        // DownloadAssessmentPDF with DocumentType=pdf
        await Assessmentservice.downloadAssessmentPDF({
          assessmentId,
          sessionID,
          documentType: "pdf",
          language: "en"
        });
      } else {
        await Assessmentservice.downloadObservationPDF(0);
      }
      setLoading(false);
      return;
    }

    if (assessmentId > 0) {
      if (pdfNames.includes(name)) {
        // DownloadAssessmentPDF with DocumentType=pdf
        await Assessmentservice.downloadAssessmentPDF({
          assessmentId,
          sessionID,
          documentType: "pdf",
          language: "en"
        });
      } else if (name === "Ohio Waiver Service Plan") {
        // DownloadAssessmentPDF with DocumentType=viewreport_pdf
        await Assessmentservice.downloadAssessmentPDF({
          assessmentId,
          sessionID,
          documentType: "viewreport_pdf",
          language: "en"
        });
      } else {
        // DownloadObservationPDF with obx_id
        await Assessmentservice.downloadObservationPDF(obx_id);
      }
    } else {
      alert('Assessment ID not found or invalid');
    }
  } catch (error) {
    console.error('Error in handleDownloadPDF:', error);
    alert('Error downloading PDF. Please try again.');
  }
  setLoading(false);
};

  // Category filter state
  const [selectedCategory, setSelectedCategory] = useState('');

  // Helper: get unique categories
  const getUniqueCategories = () => {
    const categories = [...new Set(assessments.map(assessment => assessment.category))];
    return categories;
  };

  // Status badge class
  const getStatusBadgeClass = (status) => {
    if (!status) return 'status-badge default';
    switch (status.toLowerCase()) {
      case 'completed':
        return 'status-badge completed';
      case 'in progress':
        return 'status-badge in-progress';
      case 'not started':
        return 'status-badge not-started';
      default:
        return 'status-badge default';
    }
  };

  // Date formatting
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const year = date.getFullYear();
    return `${month}/${day}/${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  };

  const parseDateForFilter = (value) => {
    if (!value) return NaN;
    const direct = new Date(value);
    if (!isNaN(direct.getTime())) {
      return new Date(direct.getFullYear(), direct.getMonth(), direct.getDate()).getTime();
    }
    const match = String(value).trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (match) {
      const month = Number(match[1]) - 1;
      const day = Number(match[2]);
      const year = Number(match[3]);
      return new Date(year, month, day).getTime();
    }
    return NaN;
  };

  const normalizeDateForFilter = (value) => {
    const time = parseDateForFilter(value);
    if (isNaN(time)) return value ? value.toString().toLowerCase() : '';
    const date = new Date(time);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`.toLowerCase();
  };

  // Archived history state
  const [showArchivedHistory, setShowArchivedHistory] = useState(false);
  const [archivedData, setArchivedData] = useState([]);
  const [archivedDataBackup, setArchivedDataBackup] = useState([]);
  const [selectedArchivedItem, setSelectedArchivedItem] = useState(null);
  const [selectedHraName, setSelectedHraName] = useState('');
  const [archivedCurrentPage, setArchivedCurrentPage] = useState(1);
  const [archivedItemsPerPage] = useState(10);
  // Sorting/filtering for archived table
  const [archivedSortConfig, setArchivedSortConfig] = useState({ key: null, direction: null });
  const [archivedOpenDropdown, setArchivedOpenDropdown] = useState(null);
  const [archivedShowFilterPanel, setArchivedShowFilterPanel] = useState(null);
  const [archivedFilteredData, setArchivedFilteredData] = useState([]);

  // Row click handler: load archived history for assessment
  const handleRowClick = async (assessment) => {
    setLoading(true);
    try {
      setShowArchivedHistory(true);
      setSelectedArchivedItem(null);
      setSelectedHraName(assessment.hra_name || assessment.name || '');
      const response = await Assessmentservice.getArchivedAssessment(assessment.hra_id);
      if (response && response.data) {
        const transformedData = response.data.map(item => ({
          status: item.status === "2" ? "Completed" : item.status === "1" ? "In Progress" : "Not Started",
          registrar: item.user_name,
          source: item.ext_source || "Manual",
          createDate: item.create_date,
          startDate: item.start_date,
          lastUpdated: item.event_date,
          completedDate: item.complete_date,
          version: item.member_version,
          score: item.score,
          cmCase: item.case_id,
          obx_id: item.obx_id // keep for key
        }));
        setArchivedData(transformedData);
        setArchivedDataBackup(transformedData);
        setArchivedFilteredData(transformedData);
      } else {
        setArchivedData([]);
        setArchivedFilteredData([]);
      }
    } catch (error) {
      setArchivedData([]);
      setArchivedFilteredData([]);
    }
    setArchivedSortConfig({ key: null, direction: null });
    setArchivedOpenDropdown(null);
    setArchivedShowFilterPanel(null);
    setArchivedCurrentPage(1);
    setLoading(false);
  };
// const handleDownloadPDF = async (selectedArchivedItem) => {
//   setLoading(true);  
//   try {
//     if (!selectedArchivedItem) {
//       alert('No archived item selected');
//       return;
//     }

//     // Get the stored archived assessment data
//     const storedData = JSON.parse(sessionStorage.getItem('archivedAssessmentData'));
//     if (!storedData) {
//       alert('No archived assessment data found');
//       return;
//     }
//     // Find the matching record with the selected item
//     const selectedRecord = storedData.find(item =>
//       item.create_date === selectedArchivedItem.createDate &&
//       item.user_name === selectedArchivedItem.registrar
//     );

//     if (!selectedRecord || !selectedRecord.obx_id) {
//       alert('OBX ID not found for selected record');
//       return;
//     }

//     // Check if the status is "In Progress"
//     if (selectedArchivedItem.status === "In Progress") {
//       alert('Cannot download PDF for In Progress assessments');
//       return;
//     }

//     // Call the API to download the PDF
//     await Assessmentservice.downloadObservationPDF(selectedRecord.obx_id);
//   } catch (error) {
//     console.error('Error in handleDownloadPDF:', error);
//     alert('Error downloading PDF. Please try again.');
//   }
//   setLoading(false);
// };
// const handleViewReport = async (selectedArchivedItem) => {
//   setLoading(true);
//   try {
//     if (!selectedArchivedItem) {
//       console.error('No archived item selected');
//       return;
//     }

//     // Check if status is "In Progress"
//     if (selectedArchivedItem.status === "In Progress") {
//       // Store the status in session storage for the popup
//       sessionStorage.setItem('assessmentViewStatus', 'InProgress');

//       // Calculate the centered position for the popup
//       const width = 1000;
//       const height = 800;
//       const left = (window.screen.width - width) / 2;
//       const top = (window.screen.height - height) / 2;

//       // Open the view report in a popup window
//       const popupWindow = window.open(
//         '/view-report',
//         'ViewReport',
//         `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,status=no`
//       );

//       if (popupWindow) {
//         popupWindow.focus();
//       } else {
//         alert('Please allow popups for this website to view the report.');
//       }
//       return;
//     }

//     // Get the stored archived assessment data
//     const storedData = JSON.parse(sessionStorage.getItem('archivedAssessmentData'));
//     if (!storedData) {
//       alert('No archived assessment data found');
//       return;
//     }
//     // Find the matching record with the selected item
//     const selectedRecord = storedData.find(item =>
//       item.create_date === selectedArchivedItem.createDate &&
//       item.user_name === selectedArchivedItem.registrar
//     );

//     if (!selectedRecord || !selectedRecord.obx_id) {
//       alert('OBX ID not found for selected record');
//       return;
//     }

//     // Call the API with the obx_id from the stored data
//     const response = await Assessmentservice.getAssessmentQuestionAnswer(selectedRecord.obx_id);

//     if (response && response.data) {
//       // Store the status and report data in session storage
//       sessionStorage.setItem('assessmentViewStatus', 'Completed');
//       sessionStorage.setItem('assessmentQuestionAnswer', response.data);

//       // Calculate the centered position for the popup
//       const width = 1000;
//       const height = 800;
//       const left = (window.screen.width - width) / 2;
//       const top = (window.screen.height - height) / 2;

//       // Open the view report in a popup window
//       const popupWindow = window.open(
//         '/view-report',
//         'ViewReport',
//         `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,status=no`
//       );

//       if (popupWindow) {
//         popupWindow.focus();
//       } else {
//         alert('Please allow popups for this website to view the report.');
//       }
//     }
//   } catch (error) {
//     console.error('Error in handleViewReport:', error);
//     alert('Error viewing report. Please try again.');
//   }
//   setLoading(false);
// };

  // Archived table sorting/filter logic
  const archivedKeyMap = {
    status: ['status'],
    registrar: ['registrar'],
    source: ['source'],
    create: ['createDate'],
    start: ['startDate'],
    lastUpdated: ['lastUpdated'],
    completed: ['completedDate'],
    version: ['version'],
    score: ['score'],
    cmCase: ['cmCase']
  };

  const getArchivedSortValue = (item, key) => {
    const keys = archivedKeyMap[key] || [key];
    let value = '';
    for (let k of keys) {
      if (item[k] !== undefined) {
        value = item[k];
        break;
      }
    }
    return value;
  };

  const archivedSortedData = React.useMemo(() => {
    if (!archivedSortConfig.key || !archivedSortConfig.direction) return archivedFilteredData;
    return [...archivedFilteredData].sort((a, b) => {
      const valA = getArchivedSortValue(a, archivedSortConfig.key);
      const valB = getArchivedSortValue(b, archivedSortConfig.key);
      // Numeric sort for numbers
      if (archivedSortConfig.key === 'score' && !isNaN(Number(valA)) && !isNaN(Number(valB))) {
        return archivedSortConfig.direction === 'asc' ? Number(valA) - Number(valB) : Number(valB) - Number(valA);
      }
      // Date sort for date strings
      if (["create", "start", "lastUpdated", "completed"].includes(archivedSortConfig.key)) {
        const dateA = new Date(valA);
        const dateB = new Date(valB);
        if (!isNaN(dateA) && !isNaN(dateB)) {
          return archivedSortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
        }
      }
      // String sort (case-insensitive)
      const strA = valA ? valA.toString().toLowerCase() : '';
      const strB = valB ? valB.toString().toLowerCase() : '';
      if (archivedSortConfig.direction === 'asc') {
        return strA.localeCompare(strB);
      } else {
        return strB.localeCompare(strA);
      }
    });
  }, [archivedFilteredData, archivedSortConfig]);

  // Archived filter panel
  const ArchivedFilterPanel = ({ columnKey, isOpen }) => {
    const [filterValues, setFilterValues] = useState({
      condition1: { operator: 'Is equal to', value: '' },
      condition2: { operator: 'Is equal to', value: '' },
      logicalOperator: 'And'
    });
    const [focusedFilterInput, setFocusedFilterInput] = useState(null);
    const condition1Ref = useRef(null);
    const condition2Ref = useRef(null);
    useEffect(() => {
      if (focusedFilterInput === 'condition1' && condition1Ref.current) {
        condition1Ref.current.focus();
      } else if (focusedFilterInput === 'condition2' && condition2Ref.current) {
        condition2Ref.current.focus();
      }
    }, [focusedFilterInput]);
    if (!isOpen) return null;
    const operators = [
      'Is equal to',
      'Is not equal to',
      'Contains',
      'Does not contain',
      'Starts with',
      'Ends with',
      'Is greater than',
      'Is less than'
    ];
    const applyFilter = () => {
      const keys = archivedKeyMap[columnKey] || [columnKey];
      let filtered = archivedDataBackup.filter(item => {
        let val1 = '';
        for (let k of keys) {
          if (item[k] !== undefined) { val1 = item[k]; break; }
        }
        let val2 = '';
        for (let k of keys) {
          if (item[k] !== undefined) { val2 = item[k]; break; }
        }
        const val1Str = val1 ? val1.toString().toLowerCase() : '';
        const filter1Str = filterValues.condition1.value ? filterValues.condition1.value.toString().toLowerCase() : '';
        const val2Str = val2 ? val2.toString().toLowerCase() : '';
        const filter2Str = filterValues.condition2.value ? filterValues.condition2.value.toString().toLowerCase() : '';

        let cond1 = true;
        let cond2 = true;

        if (filter1Str) {
          switch (filterValues.condition1.operator) {
            case 'Is equal to':
              cond1 = val1Str === filter1Str;
              break;
            case 'Is not equal to':
              cond1 = val1Str !== filter1Str;
              break;
            case 'Contains':
              cond1 = val1Str.includes(filter1Str);
              break;
            case 'Does not contain':
              cond1 = !val1Str.includes(filter1Str);
              break;
            case 'Starts with':
              cond1 = val1Str.startsWith(filter1Str);
              break;
            case 'Ends with':
              cond1 = val1Str.endsWith(filter1Str);
              break;
            case 'Is greater than':
              cond1 = val1Str > filter1Str;
              break;
            case 'Is less than':
              cond1 = val1Str < filter1Str;
              break;
            default:
              cond1 = true;
          }
        }
        if (filter2Str) {
          switch (filterValues.condition2.operator) {
            case 'Is equal to':
              cond2 = val2Str === filter2Str;
              break;
            case 'Is not equal to':
              cond2 = val2Str !== filter2Str;
              break;
            case 'Contains':
              cond2 = val2Str.includes(filter2Str);
              break;
            case 'Does not contain':
              cond2 = !val2Str.includes(filter2Str);
              break;
            case 'Starts with':
              cond2 = val2Str.startsWith(filter2Str);
              break;
            case 'Ends with':
              cond2 = val2Str.endsWith(filter2Str);
              break;
            case 'Is greater than':
              cond2 = val2Str > filter2Str;
              break;
            case 'Is less than':
              cond2 = val2Str < filter2Str;
              break;
            default:
              cond2 = true;
          }
        }
        if (!filter1Str && !filter2Str) return true;
        if (filterValues.logicalOperator === 'And') {
          return cond1 && cond2;
        } else {
          if (!filter1Str) return cond2;
          if (!filter2Str) return cond1;
          return cond1 || cond2;
        }
      });
      setArchivedFilteredData(filtered);
      setArchivedShowFilterPanel(null);
      setArchivedSortConfig({ key: null, direction: null });
      setArchivedCurrentPage(1);
    };
    const clearFilter = () => {
      setFilterValues({
        condition1: { operator: 'Is equal to', value: '' },
        condition2: { operator: 'Is equal to', value: '' },
        logicalOperator: 'And'
      });
      setArchivedFilteredData(archivedDataBackup);
      setArchivedShowFilterPanel(null);
      setArchivedSortConfig({ key: null, direction: null });
      setArchivedCurrentPage(1);
    };
    return (
      <div className="filter-panel" onClick={(e) => e.stopPropagation()}>
        
        <div className="filter-content">
          <div className="filter-instruction">Show items with value that:</div>
          <div className="filter-condition" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <select
              value={filterValues.condition1.operator}
              onChange={(e) => setFilterValues(v => ({ ...v, condition1: { ...v.condition1, operator: e.target.value } }))}
              className="filter-operator"
            >
              {operators.map(op => (
                <option key={op} value={op}>{op}</option>
              ))}
            </select>
            <input
              ref={condition1Ref}
              type="text"
              value={filterValues.condition1.value}
              onChange={(e) => setFilterValues(v => ({ ...v, condition1: { ...v.condition1, value: e.target.value } }))}
              className="filter-input"
              placeholder="Enter value"
              onFocus={() => setFocusedFilterInput('condition1')}
              onClick={() => setFocusedFilterInput('condition1')}
            />
          </div>
          <div className="filter-logical">
            <select
              value={filterValues.logicalOperator}
              onChange={(e) => setFilterValues(v => ({ ...v, logicalOperator: e.target.value }))}
              className="filter-logical-operator"
            >
              <option value="And">And</option>
              <option value="Or">Or</option>
            </select>
          </div>
          <div className="filter-condition" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <select
              value={filterValues.condition2.operator}
              onChange={(e) => setFilterValues(v => ({ ...v, condition2: { ...v.condition2, operator: e.target.value } }))}
              className="filter-operator"
            >
              {operators.map(op => (
                <option key={op} value={op}>{op}</option>
              ))}
            </select>
            <input
              ref={condition2Ref}
              type="text"
              value={filterValues.condition2.value}
              onChange={(e) => setFilterValues(v => ({ ...v, condition2: { ...v.condition2, value: e.target.value } }))}
              className="filter-input"
              placeholder="Enter value"
              onFocus={() => setFocusedFilterInput('condition2')}
              onClick={() => setFocusedFilterInput('condition2')}
            />
          </div>
          <div className="filter-actions">
            <button
              className="filter-btn apply-btn"
              onClick={applyFilter}
            >
              Filter
            </button>
            <button
              className="filter-btn clear-btn"
              onClick={clearFilter}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Archived column dropdown
  const ArchivedColumnDropdown = ({ columnKey, isOpen }) => {
    if (!isOpen) return null;
    return (
      <div className="column-dropdown" onClick={(e) => e.stopPropagation()}>
        <div className="dropdown-item" onClick={() => { setArchivedSortConfig({ key: columnKey, direction: 'asc' }); setArchivedOpenDropdown(null); }}>
          <span className="sort-icon">↑</span> Sort (asc)
        </div>
        <div className="dropdown-item" onClick={() => { setArchivedSortConfig({ key: columnKey, direction: 'desc' }); setArchivedOpenDropdown(null); }}>
          <span className="sort-icon">↓</span> Sort (desc)
        </div>
        <div className="dropdown-item filter-item" onClick={() => { setArchivedShowFilterPanel(columnKey); setArchivedOpenDropdown(null); }}>
          <span className="filter-icon">⚬</span> Filter
        </div>
      </div>
    );
  };

  // Filter assessments by category
  useEffect(() => {
    if (selectedCategory === '') {
      setFilteredAssessments(assessments);
    } else {
      setFilteredAssessments(
        assessments.filter(a => a.category === selectedCategory)
      );
    }
  }, [selectedCategory, assessments]);

  // Filter logic
  // Move filter logic into FilterPanel, lift only setFilteredAssessments and setShowFilterPanel

  // FilterPanel component
  const FilterPanel = ({ columnKey, isOpen }) => {
    const [filterValues, setFilterValues] = useState({
      condition1: { operator: 'Is equal to', value: '' },
      condition2: { operator: 'Is equal to', value: '' },
      logicalOperator: 'And'
    });
    const [focusedFilterInput, setFocusedFilterInput] = useState(null);
    const condition1Ref = useRef(null);
    const condition2Ref = useRef(null);
    useEffect(() => {
      if (focusedFilterInput === 'condition1' && condition1Ref.current) {
        condition1Ref.current.focus();
      } else if (focusedFilterInput === 'condition2' && condition2Ref.current) {
        condition2Ref.current.focus();
      }
    }, [focusedFilterInput]);
    if (!isOpen) return null;
    const operators = [
      'Is equal to',
      'Is not equal to',
      'Contains',
      'Does not contain',
      'Starts with',
      'Ends with',
      'Is greater than',
      'Is less than'
    ];
    const handleInputFocus = (inputKey) => {
      setFocusedFilterInput(inputKey);
    };
    const keyMap = {
      status: ['member_hra_status', 'status'],
      category: ['hrA_CATEGORY_NAME', 'category'],
      name: ['hra_name', 'name'],
      create: ['create_date', 'create', 'start_date'],
      start: ['start_date', 'start'],
      lastUpdated: ['evenT_DATE', 'eventT_DATE', 'last_update_date'],
      completed: ['complete_date', 'completed'],
      source: ['ext_source', 'source'],
      oltpArchive: ['oltpArchive']
    };
    const applyFilter = () => {
      const keys = keyMap[columnKey] || [columnKey];
      const isDateColumn = ['create', 'start', 'lastUpdated', 'completed'].includes(columnKey);
      let filtered = assessments.filter(item => {
        let val1 = '';
        for (let k of keys) {
          if (item[k] !== undefined) { val1 = item[k]; break; }
        }
        let val2 = '';
        for (let k of keys) {
          if (item[k] !== undefined) { val2 = item[k]; break; }
        }
        const val1Str = isDateColumn ? normalizeDateForFilter(val1) : (val1 ? val1.toString().toLowerCase() : '');
        const filter1Str = isDateColumn ? normalizeDateForFilter(filterValues.condition1.value) : (filterValues.condition1.value ? filterValues.condition1.value.toString().toLowerCase() : '');
        const val2Str = isDateColumn ? normalizeDateForFilter(val2) : (val2 ? val2.toString().toLowerCase() : '');
        const filter2Str = isDateColumn ? normalizeDateForFilter(filterValues.condition2.value) : (filterValues.condition2.value ? filterValues.condition2.value.toString().toLowerCase() : '');
        const val1Date = parseDateForFilter(val1);
        const filter1Date = parseDateForFilter(filterValues.condition1.value);
        const val2Date = parseDateForFilter(val2);
        const filter2Date = parseDateForFilter(filterValues.condition2.value);

        let cond1 = true;
        let cond2 = true;

        // Only apply condition if filter value is set
        if (filter1Str) {
          switch (filterValues.condition1.operator) {
            case 'Is equal to':
              cond1 = val1Str === filter1Str;
              break;
            case 'Is not equal to':
              cond1 = val1Str !== filter1Str;
              break;
            case 'Contains':
              cond1 = val1Str.includes(filter1Str);
              break;
            case 'Does not contain':
              cond1 = !val1Str.includes(filter1Str);
              break;
            case 'Starts with':
              cond1 = val1Str.startsWith(filter1Str);
              break;
            case 'Ends with':
              cond1 = val1Str.endsWith(filter1Str);
              break;
            case 'Is greater than':
              cond1 = isDateColumn && !isNaN(val1Date) && !isNaN(filter1Date)
                ? val1Date > filter1Date
                : val1Str > filter1Str;
              break;
            case 'Is less than':
              cond1 = isDateColumn && !isNaN(val1Date) && !isNaN(filter1Date)
                ? val1Date < filter1Date
                : val1Str < filter1Str;
              break;
            default:
              cond1 = true;
          }
        }
        if (filter2Str) {
          switch (filterValues.condition2.operator) {
            case 'Is equal to':
              cond2 = val2Str === filter2Str;
              break;
            case 'Is not equal to':
              cond2 = val2Str !== filter2Str;
              break;
            case 'Contains':
              cond2 = val2Str.includes(filter2Str);
              break;
            case 'Does not contain':
              cond2 = !val2Str.includes(filter2Str);
              break;
            case 'Starts with':
              cond2 = val2Str.startsWith(filter2Str);
              break;
            case 'Ends with':
              cond2 = val2Str.endsWith(filter2Str);
              break;
            case 'Is greater than':
              cond2 = isDateColumn && !isNaN(val2Date) && !isNaN(filter2Date)
                ? val2Date > filter2Date
                : val2Str > filter2Str;
              break;
            case 'Is less than':
              cond2 = isDateColumn && !isNaN(val2Date) && !isNaN(filter2Date)
                ? val2Date < filter2Date
                : val2Str < filter2Str;
              break;
            default:
              cond2 = true;
          }
        }

        // If both filter values are empty, show all
        if (!filter1Str && !filter2Str) return true;

        if (filterValues.logicalOperator === 'And') {
          return cond1 && cond2;
        } else {
          // For 'Or', if only one filter is set, use only that condition
          if (!filter1Str) return cond2;
          if (!filter2Str) return cond1;
          return cond1 || cond2;
        }
      });
      setFilteredAssessments(filtered);
      setSelectedAssessmentRow(null);
      setShowArchivedHistory(false);
      setShowFilterPanel(null);
    };
    const clearFilter = () => {
      setFilterValues({
        condition1: { operator: 'Is equal to', value: '' },
        condition2: { operator: 'Is equal to', value: '' },
        logicalOperator: 'And'
      });
      setFilteredAssessments(assessments);
      setSelectedAssessmentRow(null);
      setShowArchivedHistory(false);
      setShowFilterPanel(null);
    };
    return (
      <div className="filter-panel" onClick={(e) => e.stopPropagation()}>
        <div className="filter-header">
          <span className="filter-icon">⚬</span>
          Apply filter
        </div>
        <div className="filter-content">
          <div className="filter-instruction">Show items with value that:</div>
          <div className="filter-condition">
            <select
              value={filterValues.condition1.operator}
              onChange={(e) => setFilterValues(v => ({ ...v, condition1: { ...v.condition1, operator: e.target.value } }))}
              className="filter-operator"
            >
              {operators.map(op => (
                <option key={op} value={op}>{op}</option>
              ))}
            </select>
            <input
              ref={condition1Ref}
              type="text"
              value={filterValues.condition1.value}
              onChange={(e) => setFilterValues(v => ({ ...v, condition1: { ...v.condition1, value: e.target.value } }))}
              className="filter-input"
              placeholder="Enter value"
              onFocus={() => handleInputFocus('condition1')}
              onClick={() => handleInputFocus('condition1')}
            />
          </div>
          <div className="filter-logical">
            <select
              value={filterValues.logicalOperator}
              onChange={(e) => setFilterValues(v => ({ ...v, logicalOperator: e.target.value }))}
              className="filter-logical-operator"
            >
              <option value="And">And</option>
              <option value="Or">Or</option>
            </select>
          </div>
          <div className="filter-condition">
            <select
              value={filterValues.condition2.operator}
              onChange={(e) => setFilterValues(v => ({ ...v, condition2: { ...v.condition2, operator: e.target.value } }))}
              className="filter-operator"
            >
              {operators.map(op => (
                <option key={op} value={op}>{op}</option>
              ))}
            </select>
            <input
              ref={condition2Ref}
              type="text"
              value={filterValues.condition2.value}
              onChange={(e) => setFilterValues(v => ({ ...v, condition2: { ...v.condition2, value: e.target.value } }))}
              className="filter-input"
              placeholder="Enter value"
              onFocus={() => handleInputFocus('condition2')}
              onClick={() => handleInputFocus('condition2')}
            />
          </div>
          <div className="filter-actions">
            <button
              className="filter-btn apply-btn"
              onClick={applyFilter}
            >
              Filter
            </button>
            <button
              className="filter-btn clear-btn"
              onClick={clearFilter}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Table rendering with sorting
    // Direct header sort handler
    const handleHeaderSort = (columnKey) => {
      setSortConfig(prev => {
        if (prev.key === columnKey) {
          // Toggle direction
          return { key: columnKey, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
        } else {
          // Default to ascending
          return { key: columnKey, direction: 'asc' };
        }
      });
      setOpenDropdown(null);
    };
  const getSortValue = (item, key) => {
    // Map keys to actual data fields
    const keyMap = {
      status: ['member_hra_status', 'status'],
      category: ['hrA_CATEGORY_NAME', 'category'],
      name: ['hra_name', 'name'],
      create: ['create_date', 'create', 'start_date'],
      start: ['start_date', 'start'],
      lastUpdated: ['evenT_DATE', 'eventT_DATE', 'last_update_date'],
      completed: ['complete_date', 'completed'],
      source: ['ext_source', 'source'],
      oltpArchive: ['oltpArchive']
    };
    const keys = keyMap[key] || [key];
    let value = '';
    for (let k of keys) {
      if (item[k] !== undefined) {
        value = item[k];
        break;
      }
    }
    return value;
  };

  // Robust sorting function (like auto.js)
  const sortedData = React.useMemo(() => {
    if (!sortConfig.key || !sortConfig.direction) return filteredAssessments;
    return [...filteredAssessments].sort((a, b) => {
      const valA = getSortValue(a, sortConfig.key);
      const valB = getSortValue(b, sortConfig.key);
      // Numeric sort for numbers
      if (typeof valA === 'number' && typeof valB === 'number') {
        return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
      }
      // Date sort for date strings
      if (sortConfig.key === 'create' || sortConfig.key === 'start' || sortConfig.key === 'lastUpdated' || sortConfig.key === 'completed') {
        const dateA = new Date(valA);
        const dateB = new Date(valB);
        if (!isNaN(dateA) && !isNaN(dateB)) {
          return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
        }
      }
      // String sort (case-insensitive)
      const strA = valA ? valA.toString().toLowerCase() : '';
      const strB = valB ? valB.toString().toLowerCase() : '';
      if (sortConfig.direction === 'asc') {
        return strA.localeCompare(strB);
      } else {
        return strB.localeCompare(strA);
      }
    });
  }, [filteredAssessments, sortConfig]);
  // ...existing code...

  const totalItems = sortedData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const currentItems = sortedData.slice(startIndex, endIndex);

  // Archived table rendering
  const archivedStartIdx = (archivedCurrentPage - 1) * archivedItemsPerPage;
  const archivedEndIdx = Math.min(archivedStartIdx + archivedItemsPerPage, archivedSortedData.length);
  const currentArchivedItems = archivedSortedData.slice(archivedStartIdx, archivedEndIdx);

  // Pagination handlers
  const handleFirstPage = () => setCurrentPage(1);
  const handlePreviousPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
  const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
  const handleLastPage = () => setCurrentPage(totalPages);

  // Sorting functionality
  const handleSort = (columnKey, direction) => {
    setSortConfig({ key: columnKey, direction });
    setOpenDropdown(null);
  };

  // Apply column filter
  const handleColumnFilter = (columnKey) => {
    setShowFilterPanel(columnKey);
    setOpenDropdown(null);
  };

  // Toggle dropdown
  const toggleDropdown = (columnKey) => {
    setOpenDropdown(openDropdown === columnKey ? null : columnKey);
  };

  // Column header dropdown component
  const ColumnDropdown = ({ columnKey, isOpen }) => {
    if (!isOpen) return null;
    return (
      <div className="column-dropdown" onClick={(e) => e.stopPropagation()}>
        <div className="dropdown-item" onClick={() => handleSort(columnKey, 'asc')}>
          <span className="sort-icon">↑</span> Sort (asc)
        </div>
        <div className="dropdown-item" onClick={() => handleSort(columnKey, 'desc')}>
          <span className="sort-icon">↓</span> Sort (desc)
        </div>
        <div className="dropdown-item filter-item" onClick={() => handleColumnFilter(columnKey)}>
          <span className="filter-icon">⚬</span> Filter
        </div>
      </div>
    );
  };



  return (
    <div className="assessment-container">
       {loading && <Loading />}
      <div className="assessment-section">
        <div className="assessment-header">
          <h2>Assessments</h2>
          {/* Category filter dropdown */}
          
        </div>
        <div className="assessment-table-container">
          <table className="assessment-table">
            <thead>
              <tr>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('status'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    STATUS
                    {sortConfig.key === 'status' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('status'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="status" isOpen={openDropdown === 'status'} />
                  <FilterPanel columnKey="status" isOpen={showFilterPanel === 'status'} />
                </th>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('category'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    CATEGORY
                    {sortConfig.key === 'category' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('category'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="category" isOpen={openDropdown === 'category'} />
                  <FilterPanel columnKey="category" isOpen={showFilterPanel === 'category'} />
                </th>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('name'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    NAME
                    {sortConfig.key === 'name' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('name'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="name" isOpen={openDropdown === 'name'} />
                  <FilterPanel columnKey="name" isOpen={showFilterPanel === 'name'} />
                </th>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('create'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    CREATE
                    {sortConfig.key === 'create' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('create'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="create" isOpen={openDropdown === 'create'} />
                  <FilterPanel columnKey="create" isOpen={showFilterPanel === 'create'} />
                </th>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('start'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    START
                    {sortConfig.key === 'start' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('start'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="start" isOpen={openDropdown === 'start'} />
                  <FilterPanel columnKey="start" isOpen={showFilterPanel === 'start'} />
                </th>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('lastUpdated'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    LAST UPDATED
                    {sortConfig.key === 'lastUpdated' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('lastUpdated'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="lastUpdated" isOpen={openDropdown === 'lastUpdated'} />
                  <FilterPanel columnKey="lastUpdated" isOpen={showFilterPanel === 'lastUpdated'} />
                </th>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('completed'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    COMPLETED
                    {sortConfig.key === 'completed' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('completed'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="completed" isOpen={openDropdown === 'completed'} />
                  <FilterPanel columnKey="completed" isOpen={showFilterPanel === 'completed'} />
                </th>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('source'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    SOURCE
                    {sortConfig.key === 'source' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('source'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="source" isOpen={openDropdown === 'source'} />
                  <FilterPanel columnKey="source" isOpen={showFilterPanel === 'source'} />
                </th>
                <th className="sortable-header">
                  <span onClick={(e) => { e.stopPropagation(); handleHeaderSort('oltpArchive'); }} style={{ cursor: 'pointer', marginRight: 4 }}>
                    OLTP ARCHIVE
                    {sortConfig.key === 'oltpArchive' && (
                      <span style={{ marginLeft: 4 }}>
                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </span>
                  <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); toggleDropdown('oltpArchive'); }} style={{ cursor: 'pointer' }}>▼</span>
                  <ColumnDropdown columnKey="oltpArchive" isOpen={openDropdown === 'oltpArchive'} />
                  <FilterPanel columnKey="oltpArchive" isOpen={showFilterPanel === 'oltpArchive'} />
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="9" className="no-data">No assessments found</td>
                </tr>
              ) : (
                currentItems.map((assessment, idx) => (
                  <tr
                    key={assessment.hra_id ? `${assessment.hra_id}-${assessment.rownum}` : `row-${idx}`}
                    className="assessment-row"
                    style={{ cursor: 'pointer', backgroundColor: selectedAssessmentRow === assessment ? '#1598c079' : undefined, color: selectedAssessmentRow === assessment ? '#fff' : undefined }}
                    onClick={() => { setSelectedAssessmentRow(assessment); handleRowClick(assessment); }}
                  >
                    <td>
                      <span className={getStatusBadgeClass(assessment.member_hra_status || assessment.status)}>
                        {toTitleCase(assessment.member_hra_status || assessment.status || '-')}
                      </span>
                    </td>
                    <td title={assessment.hrA_CATEGORY_NAME || assessment.category || '-'}>{assessment.hrA_CATEGORY_NAME || assessment.category || '-'}</td>
                    {/* <td>{assessment.hra_name || assessment.name || '-'}</td> */}
                      <td title={assessment.hra_name || assessment.name || '-'}>{assessment.hra_name || assessment.name || '-'}</td>
                    <td>{formatOnlyDate(assessment.create_date || assessment.create || assessment.start_date)}</td>
                    <td>{formatOnlyDate(assessment.start_date || assessment.start)}</td>
                    <td>{formatOnlyDate(assessment.evenT_DATE || assessment.eventT_DATE || assessment.last_update_date)}</td>
                    <td>{formatOnlyDate(assessment.complete_date || assessment.completed)}</td>
                    <td>{assessment.ext_source || assessment.source || '-'}</td>
                    <td>{assessment.oltpArchive || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <div className="assessment-footer">
            <div className="pagination-controls">
              <button className="pagination-btn first-btn" onClick={handleFirstPage} disabled={currentPage === 1} title="First page">⟪</button>
              <button className="pagination-btn prev-btn" onClick={handlePreviousPage} disabled={currentPage === 1} title="Previous page">⟨</button>
              <span className="page-indicator">{currentPage}</span>
              <button className="pagination-btn next-btn" onClick={handleNextPage} disabled={currentPage === totalPages || totalPages === 0} title="Next page">⟩</button>
              <button className="pagination-btn last-btn" onClick={handleLastPage} disabled={currentPage === totalPages || totalPages === 0} title="Last page">⟫</button>
            </div>
            <div className="results-count">
              {totalItems === 0 ? "0 - 0 of 0 items" : `${startIndex + 1} - ${endIndex} of ${totalItems} items`}
            </div>
          </div>
        </div>
        {/* Archived History Section */}
        {showArchivedHistory && (
          <div className="archived-history-section">
            <div className="assessment-header">
              <h2>
                {(!archivedData || archivedData.length === 0)
                  ? "No More Archived History Available!!"
                  : `${selectedHraName} Archived History`
                }
              
              </h2>
            </div>
            <div className="archived-history-table-container">
              <table className="archived-history-table">
                <thead>
                  <tr>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'status' ? null : 'status'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'status' ? { key: 'status', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'status', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Status
                          {archivedSortConfig.key === 'status' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'status' ? null : 'status'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="status" isOpen={archivedOpenDropdown === 'status'} />
                        <ArchivedFilterPanel columnKey="status" isOpen={archivedShowFilterPanel === 'status'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'registrar' ? null : 'registrar'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'registrar' ? { key: 'registrar', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'registrar', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Registrar
                          {archivedSortConfig.key === 'registrar' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'registrar' ? null : 'registrar'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="registrar" isOpen={archivedOpenDropdown === 'registrar'} />
                        <ArchivedFilterPanel columnKey="registrar" isOpen={archivedShowFilterPanel === 'registrar'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'source' ? null : 'source'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'source' ? { key: 'source', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'source', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Source
                          {archivedSortConfig.key === 'source' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'source' ? null : 'source'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="source" isOpen={archivedOpenDropdown === 'source'} />
                        <ArchivedFilterPanel columnKey="source" isOpen={archivedShowFilterPanel === 'source'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'create' ? null : 'create'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'create' ? { key: 'create', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'create', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Create
                          {archivedSortConfig.key === 'create' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'create' ? null : 'create'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="create" isOpen={archivedOpenDropdown === 'create'} />
                        <ArchivedFilterPanel columnKey="create" isOpen={archivedShowFilterPanel === 'create'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'start' ? null : 'start'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'start' ? { key: 'start', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'start', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Start
                          {archivedSortConfig.key === 'start' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'start' ? null : 'start'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="start" isOpen={archivedOpenDropdown === 'start'} />
                        <ArchivedFilterPanel columnKey="start" isOpen={archivedShowFilterPanel === 'start'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'lastUpdated' ? null : 'lastUpdated'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'lastUpdated' ? { key: 'lastUpdated', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'lastUpdated', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Last Updated
                          {archivedSortConfig.key === 'lastUpdated' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'lastUpdated' ? null : 'lastUpdated'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="lastUpdated" isOpen={archivedOpenDropdown === 'lastUpdated'} />
                        <ArchivedFilterPanel columnKey="lastUpdated" isOpen={archivedShowFilterPanel === 'lastUpdated'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'completed' ? null : 'completed'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'completed' ? { key: 'completed', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'completed', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Completed
                          {archivedSortConfig.key === 'completed' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'completed' ? null : 'completed'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="completed" isOpen={archivedOpenDropdown === 'completed'} />
                        <ArchivedFilterPanel columnKey="completed" isOpen={archivedShowFilterPanel === 'completed'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'version' ? null : 'version'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'version' ? { key: 'version', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'version', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Version
                          {archivedSortConfig.key === 'version' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'version' ? null : 'version'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="version" isOpen={archivedOpenDropdown === 'version'} />
                        <ArchivedFilterPanel columnKey="version" isOpen={archivedShowFilterPanel === 'version'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'score' ? null : 'score'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'score' ? { key: 'score', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'score', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          Score
                          {archivedSortConfig.key === 'score' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'score' ? null : 'score'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="score" isOpen={archivedOpenDropdown === 'score'} />
                        <ArchivedFilterPanel columnKey="score" isOpen={archivedShowFilterPanel === 'score'} />
                      </div>
                    </th>
                    <th className="sortable-header" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'cmCase' ? null : 'cmCase'); }} style={{ position: 'relative' }}>
                      <div className="header-label-wrapper">
                        <span style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setArchivedSortConfig(prev => prev.key === 'cmCase' ? { key: 'cmCase', direction: prev.direction === 'asc' ? 'desc' : 'asc' } : { key: 'cmCase', direction: 'asc' }); setArchivedOpenDropdown(null); }}>
                          CM Case
                          {archivedSortConfig.key === 'cmCase' && (
                            <span style={{ marginLeft: 4 }}>
                              {archivedSortConfig.direction === 'asc' ? '↑' : '↓'}
                            </span>
                          )}
                        </span>
                        <span className="dropdown-icon" onClick={(e) => { e.stopPropagation(); setArchivedOpenDropdown(archivedOpenDropdown === 'cmCase' ? null : 'cmCase'); }} style={{ cursor: 'pointer' }}>▼</span>
                      </div>
                      <div style={{ position: 'absolute', left: 0, top: '60px', width: '100%', zIndex: 10 }}>
                        <ArchivedColumnDropdown columnKey="cmCase" isOpen={archivedOpenDropdown === 'cmCase'} />
                        <ArchivedFilterPanel columnKey="cmCase" isOpen={archivedShowFilterPanel === 'cmCase'} />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentArchivedItems.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="no-data">No archived history found</td>
                    </tr>
                  ) : (
                    currentArchivedItems.map((item, index) => (
                      <tr
                        key={item.obx_id ? `${item.obx_id}-${item.createDate}` : `archived-${index}`}
                        className="archived-history-row"
                        style={{
                          cursor: 'pointer',
                          backgroundColor: selectedArchivedItem === item ? '#1598c079' : undefined,
                          color: selectedArchivedItem === item ? '#fff' : undefined
                        }}
                        onClick={() => setSelectedArchivedItem(item)}
                      >
                        <td style={{
                         
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }} title={item.status}>
                          <span className={getStatusBadgeClass(item.status)}>
                            {item.status}
                          </span>
                        </td>
                        <td title={item.registrar || '-'} style={{
                         
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}>{item.registrar || '-'}</td>
                        <td>{item.source || '-'}</td>
                        <td>
                          <span title={formatDate(item.createDate)} style={{ cursor: 'pointer', display: 'inline-block', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {formatDate(item.createDate)}
                          </span>
                        </td>
                        <td>
                          <span title={formatDate(item.startDate)} style={{ cursor: 'pointer', display: 'inline-block', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {formatDate(item.startDate)}
                          </span>
                        </td>
                        <td>
                          <span title={formatDate(item.lastUpdated)} style={{ cursor: 'pointer', display: 'inline-block', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {formatDate(item.lastUpdated)}
                          </span>
                        </td>
                        <td>
                          <span title={formatDate(item.completedDate)} style={{ cursor: 'pointer', display: 'inline-block', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {formatDate(item.completedDate)}
                          </span>
                        </td>
                        <td>{item.version || '-'}</td>
                        <td>{item.score || '0'}</td>
                        <td>{item.cmCase || '-'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              <div className="archived-history-footer">
                <div className="pagination-controls">
                  <button
                    className="pagination-btn"
                    onClick={() => setArchivedCurrentPage(1)}
                    disabled={archivedCurrentPage === 1}
                  >
                    ⟪
                  </button>
                  <button
                    className="pagination-btn"
                    onClick={() => setArchivedCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={archivedCurrentPage === 1}
                  >
                    ⟨
                  </button>
                  <span className="current-page">{archivedCurrentPage}</span>
                  <button
                    className="pagination-btn"
                    onClick={() => setArchivedCurrentPage(prev => Math.min(prev + 1, Math.ceil(archivedData.length / archivedItemsPerPage)))}
                    disabled={archivedCurrentPage === Math.ceil(archivedData.length / archivedItemsPerPage)}
                  >
                    ⟩
                  </button>
                  <button
                    className="pagination-btn"
                    onClick={() => setArchivedCurrentPage(Math.ceil(archivedData.length / archivedItemsPerPage))}
                    disabled={archivedCurrentPage === Math.ceil(archivedData.length / archivedItemsPerPage)}
                  >
                    ⟫
                  </button>
                </div>
                <div className="results-count">
                  {archivedData.length === 0
                    ? "0 - 0 of 0 items"
                    : `${Math.min((archivedCurrentPage - 1) * archivedItemsPerPage + 1, archivedData.length)} - ${Math.min(archivedCurrentPage * archivedItemsPerPage, archivedData.length)} of ${archivedData.length} items`
                  }
                </div>
              </div>
            </div>
            {/* <div className="archived-history-footer">
              <div className="pagination-controls">
                <button
                  className="pagination-btn"
                  onClick={() => setArchivedCurrentPage(1)}
                  disabled={archivedCurrentPage === 1}
                >
                  ⟪
                </button>
                <button
                  className="pagination-btn"
                  onClick={() => setArchivedCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={archivedCurrentPage === 1}
                >
                  ⟨
                </button>
                <span className="current-page">{archivedCurrentPage}</span>
                <button
                  className="pagination-btn"
                  onClick={() => setArchivedCurrentPage(prev => Math.min(prev + 1, Math.ceil(archivedData.length / archivedItemsPerPage)))}
                  disabled={archivedCurrentPage === Math.ceil(archivedData.length / archivedItemsPerPage)}
                >
                  ⟩
                </button>
                <button
                  className="pagination-btn"
                  onClick={() => setArchivedCurrentPage(Math.ceil(archivedData.length / archivedItemsPerPage))}
                  disabled={archivedCurrentPage === Math.ceil(archivedData.length / archivedItemsPerPage)}
                >
                  ⟫
                </button>
              </div>
              <div className="results-count">
                {archivedData.length === 0
                  ? "0 - 0 of 0 items"
                  : `${Math.min((archivedCurrentPage - 1) * archivedItemsPerPage + 1, archivedData.length)} - ${Math.min(archivedCurrentPage * archivedItemsPerPage, archivedData.length)} of ${archivedData.length} items`
                }
              </div>
            </div> */}
            {/* View Report and Download PDF buttons */}
            {selectedArchivedItem && (
              <div className="archived-actions-container">
                <div className="archived-actions">
                  <button
                    className="action-btn view-report"
                    onClick={() => handleViewReport(selectedArchivedItem)}
                    style={{
                      backgroundColor:'#4a90c2',
                      color: 'white',
                      padding: '8px 20px',
                      borderRadius: '4px',
                      border: 'none',
                      cursor: 'pointer',
                      fontWeight: '500',
                      minWidth: '120px',
                      marginRight: '10px'
                    }}
                  >
                    View Report
                  </button>
                  <button
                    className="action-btn download-pdf"
                    onClick={() => handleDownloadPDF(selectedArchivedItem)}
                    style={{
                      backgroundColor:'#4a90c2',
                      color: 'white',
                      padding: '8px 20px',
                      borderRadius: '4px',
                      border: 'none',
                      cursor: 'pointer',
                      fontWeight: '500',
                      minWidth: '120px',
                      marginLeft: '10px'
                    }}
                  >
                    Download PDF
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Assessment;

